(() => {
  if (window.__mrgSizeFactsInitialized) return;
  window.__mrgSizeFactsInitialized = true;

  const start = () => {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined' || !PUB_SUB_EVENTS.variantChange) {
      window.setTimeout(start, 100);
      return;
    }

    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      if (!data || !data.sectionId || !data.html) return;
      const id = `MrgProductFacts-${data.sectionId}`;
      const source = data.html.getElementById(id);
      const destination = document.getElementById(id);
      if (source && destination) destination.innerHTML = source.innerHTML;
    });
  };

  start();
})();
